import { notificationData } from "../../util/Constants";

export default function Notification({
  notifications = [],
}: {
  notifications: typeof notificationData;
}) {
  if (notifications.length === 0) {
    return (
      <div className="w-96 h-52 flex flex-col justify-center items-center bg-white rounded-xl shadow-xl border border-neutral-50 p-8 text-center">
        <p className="text-neutral-400 text-sm font-medium">
          You're all caught up!
        </p>
        <p className="text-neutral-300 text-xs mt-1">
          No new notifications right now
        </p>
      </div>
    );
  }

  return (
    <div className="w-96 bg-white rounded-xl shadow-xl border max-h-[350px] custom-scrollbar overflow-y-auto border-neutral-50 flex flex-col">
      <div className="flex justify-between items-center p-4">
        <p className="text-[22px] font-medium text-neutral-500">
          Notifications
        </p>
        <button className="text-primary-600 underline text-sm font-semibold">
          Mark all as read
        </button>
      </div>
      <div className="flex flex-col">
        {notificationData?.map((item, i) => {
          const isUnread = item.status === "unread";

          return (
            <div
              key={i}
              className={`flex items-start gap-4 p-4 cursor-pointer border-b border-neutral-50 last:border-none
        ${isUnread ? "bg-primary-50/50" : ""}
      `}
            >
              <div className="relative">
                <img
                  src={item.profile}
                  alt="item"
                  className="w-11 h-11 rounded-full"
                />

                {isUnread && (
                  <span className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-primary-600 border-2 border-white" />
                )}
              </div>

              <div className="flex-1">
                <p className={`text-start text-[15px] text-neutral-400 `}>
                  {item.name && <span className="font-bold">{item.name}</span>}{" "}
                  {item.messages}
                </p>

                <div className="flex gap-1 text-[12px] text-neutral-300 items-center">
                  <p>{item.time}</p>
                  <span className="w-[4px] h-[4px] rounded-full bg-neutral-300" />
                  <p>{item.type}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
